export default {
	about: {
		title: true,
	},
	main: {
		tagline: false,
	},
	services: {
		title: true,
	},
	accolades: {
		title: true,
	},
	widgets: {
		title: true,
	},
	testimonials: {
		title: true,
		navButtonColor: '#2f2e2e',
	},
	contact: {
		title: true,
	},
};
